import type { SubsidiaryFilterContextValue } from '@/@subsidiary/types';

export type AccountViewAsTarget = {
    /** Studio numeric org_id */
    orgId: number;
    /** Salesforce account id */
    sfAccountId: string;
    orgName: string;
};

/**
 * Resolve which org Account pages (Team / Billing / Funds) should display
 * while an internal is Viewing-as.
 *
 * - Narrowed hierarchy selection → that single org
 * - View all (or standalone) → the View-as entry org (masqueradeOrgId)
 */
export function getAccountViewAsTarget(
    filter: SubsidiaryFilterContextValue | null | undefined,
): AccountViewAsTarget | null {
    if (!filter?.isInternal || filter.masqueradeOrgId == null) return null;

    const targetOrgId =
        filter.selectedOrgIds.length === 1 ? filter.selectedOrgIds[0]! : filter.masqueradeOrgId;

    const option = [...filter.hierarchyOptions, ...filter.options].find(
        (o) => o.orgId === targetOrgId,
    );
    if (!option?.sfAccountId) return null;

    return {
        orgId: targetOrgId,
        sfAccountId: option.sfAccountId,
        orgName: option.orgName,
    };
}
